import React, { Component } from "react";
import Jumbotron from "../components/Jumbotron/Jumbotron";
import DivContent from "../components/DivContent/DivContent";
import Footer from "../components/Footer/Footer";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import {
  // InputGroup,
  // InputGroupAddon,
  // InputGroupText,
  Input,
  FormGroup,
  Label,
  Form
} from "reactstrap";
import "./page.css";

class home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      render: [],
      filter: {
        Seminar: true,
        Exhibition: true,
        Conference: true,
        Entertainment: true,
        Other: true
      }
    };
  }
  componentDidMount() {
    console.log("render");
    const database = firebase.database();
    const databaseRef = database.ref();

    databaseRef.child("Organizer").on("value", snap => {
      this.setState({
        items: JSON.stringify(snap.val()),
        render: JSON.stringify(snap.val())
      });
    });
  }

  handleCheckboxChange = event => {
    var target = event.target;
    var value = target.type === "checkbox" ? target.checked : target.value;
    var name = target.name;
    var filterUpdate = {
      ...this.state.filter,
      [name]: value
    };
    this.setState({
      filter: filterUpdate
    });
    console.log(filterUpdate);
    var items = JSON.parse(this.state.render);

    console.log(items);
    if (value) {
      var check = JSON.parse(this.state.items);
      Object.keys(check).forEach((item, index) => {
        // var search =
        var arr = check[item].type;
        if (arr !== undefined) {
          if (arr.includes(name)) {
            items[item] = check[item];
          }
        } else {
          if (name.includes("etc")) {
            items[item] = check[item];
          }
        }
      });
      this.setState({
        render: JSON.stringify(items)
      });
    } else {
      //uncheck the checkbox
      items = JSON.parse(this.state.render);
      Object.keys(items).forEach((item, index) => {
        console.log(items[item].type);
        // var search =
        var arr = items[item].type;

        if (arr !== undefined) {
          var bool = arr.some(ar => {
            return filterUpdate[ar];
          });
          console.log(bool);
          if (!bool) {
            delete items[item];
          }
        } else {
          if (!filterUpdate["etc."]) {
            delete items[item];
          }
        }
      });
      this.setState({
        render: JSON.stringify(items)
      });
    }
  };
  renderFilter() {
    const type = [
      "Seminar",
      "Exhibition",
      "Entertainment",
      "Conference",
      "Other"
    ];
    return type.map(value => (
      <FormGroup check inline key={value}>
        <Label check>
          <Input
            type="checkbox"
            defaultChecked="true"
            name={value}
            checked={this.state.filter[{ value }]}
            onChange={this.handleCheckboxChange}
          />{" "}
          {value}
        </Label>
      </FormGroup>
    ));
  }
  searchItem = event => {
    console.log(this.state.items.length);
    if (this.state.items.length < 1) {
      return;
    }
    if (event.target.value.length === 0) {
      this.setState({
        render: this.state.items
      });
    }
    var items = JSON.parse(this.state.items);
    if (
      !/^[0-9A-Za-zๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ]+$/.test(
        event.target.value
      )
    ) {
      return;
    }
    var filter = {};
    Object.keys(items).forEach((item, index) => {
      var search = item.search(new RegExp(event.target.value, "i")) !== -1;
      search =
        search ||
        items[item].description.search(new RegExp(event.target.value, "i")) !==
          -1;
      var arr = items[item].type;
      if (arr !== undefined) {
        var bool = arr.some(ar => {
          return this.state.filter[ar];
        });
      } else {
        if (this.state.filter["etc."]) {
          bool = true;
        }
      }
      if (search && bool) {
        filter[item] = items[item];
      }
    });

    this.setState({
      render: JSON.stringify(filter)
    });
  };
  render() {
    return (
      <div>
        <Jumbotron />
        <div className="form" style={{ paddingTop: "30px" }}>
          <div className="half " style={{ height: "30px" }}>
            <div className="text-center">
              <Form>Filter : {this.renderFilter()}</Form>
            </div>
          </div>
          <div className="half " style={{ height: "30px" }}>
            <div className="text-center" style={{padding : "2px"}} >
              <Input
                className="searchBox"
                placeholder="ค้นหาออแกไนเซอร์"
                onChange={this.searchItem}
              />
              {/* <Input type="file" /> */}
            </div>
          </div>
        </div>

        <DivContent listjson={this.state.render} />
        <Footer />
      </div>
    );
  }
}

export default home;



// WEBPACK FOOTER //
// ./src/Pages/home.js